import TrackingId from './getTrackingId';
import cleanObject from './cleanObject';
/*
 * Returns headers for API calls.
 *
 * @return CustomHeaders must be spread to be accepted as HeadersInit for fetch()
 */
var buildCustomHeaders = function (_a) {
    var token = _a.token, channelId = _a.channelId, clientId = _a.clientId, correlationId = _a.correlationId;
    return cleanObject({
        'X-SYF-Request-TrackingId': TrackingId.uuidValue(),
        'X-SYF-Request-CorrelationId': correlationId,
        'X-SYF-ChannelId': channelId,
        'X-SYF-ClientId': clientId,
        authorization: token && "Bearer ".concat(token)
    });
};
export default buildCustomHeaders;
